import React, { useContext, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useFormik } from 'formik'
import AlertContext from '@/product/context/alert/alertContext'
import CustomTable from '@/product/components/molecules/CustomTable'
import settingContext from '@/custom/context/setting/settingContext'
import * as Yup from 'yup'
import { useTranslation } from 'react-i18next'
import CustomDialog from '@/product/components/organisms/Dialog'
import ProductCommonContext from '@/product/context/common/commonContext'
import { mapData } from '@/product/common/components'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'

const UserAddressDetails = (props) => {
    const alertContext = useContext(AlertContext)
    const SettingContext = useContext(settingContext)
    const [isLoading, setIsLoading] = useState(true)
    const { setAlert } = alertContext
    const {
        getUserAddressDetails,
        userAddressUpdate,
        userAddressData,
        responseStatus: responseStatusCommuncation,
        clearResponse: clearResponseCommuncation,
    } = SettingContext
    const { allCountries, allStates } = useContext(ProductCommonContext)
    const [selectState, setSelectState] = useState(false)
    const { t } = useTranslation()
    const userId = props?.data?.id

    const [tableBody, setTableBody] = useState([])
    const [userAddress, setUserAddress] = useState({})
    const [mapDataValue, setmapDataValue] = useState([])
    const [toggleFullScreenPopup, setToggleFullScreenPopup] = useState(false)

    const formik = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            user_id: userId,
        },
        onSubmit: (values) => {
            setIsLoading(true)
            getUserAddressDetails(values)
        },
    })

    useEffect(() => {
        if (userAddressData) {
            setTableBody(
                userAddressData.records.length ? userAddressData.records : []
            )
        }
        setIsLoading(false)
    }, [userAddressData])

    function getStateOptions(
        country,
        allStates = [],
        ignoreStates = [],
        defaultCountry = ''
    ) {
        if (!country) country = defaultCountry

        return allStates
            .filter((state) => {
                const isCorrectCountry =
                    country && state.countryCode === country
                const isNotIgnored = !ignoreStates.includes(state.isoCode)
                return isCorrectCountry && isNotIgnored
            })
            .map((state) => ({
                show: state.name,
                value: state.isoCode,
            }))
    }

    const validationAddress = Yup.object({
        first_name: Yup.string()
            .matches(
                /^[a-zA-ZÀ-ÿ\u00C0-\u017F\u4e00-\u9fa5\s]*$/,
                t('No Special Characters and Numbers Allowed')
            )
            .min(2, t('Minimum 2 characters'))
            .max(50, t('Maximum 50 characters'))
            .required(t('Required!')),

        address1: Yup.string().required(t('Required!')),
        country: Yup.string().required(t('Required!')),
        city: Yup.string().required(t('Required!')),
        state: Yup.string()
            .nullable()
            .when('country', (country, schema) => {
                const options = getStateOptions(
                    country,
                    allStates || [],
                    global?.ignoreStates || [],
                    global?.defaultCountry || ''
                )
                const shouldBeRequired = options.length > 0

                return shouldBeRequired
                    ? schema.required(t('Required!'))
                    : schema.nullable()
            }),

        zip: Yup.string().required(t('Required!')),
        email: Yup.string()
            .email(t('Invalid Email Format'))
            .max(250, t('Maximum 250 Characters'))
            .required(t('Required!')),
        phone: Yup.string()
            .trim()
            .nullable()
            .matches(/^[0-9- +()]*$/g, t('Only numbers are allowed'))
            .required(t('Required!')),
    })

    const addressformik = useFormik({
        initialValues: {
            first_name: '',
            city: '',
            state: '',
            phone: '',
            email: '',
            zip: '',
            companyname: '',
            address1: '',
            address2: '',
            country: '',
            id: '',
        },
        validationSchema: validationAddress,
        onSubmit: (values) => {
            // setDisabled(true)

            userAddressUpdate(values)
            addressformik.resetForm()

            // setLoading(true)
        },
    })

    const onClickEdit = (id, secondId) => {
        let data = tableBody.filter((el) => el.id == id)
        if (data?.length > 0) {
            addressformik.values.first_name = data[0].first_name

            addressformik.values.address1 = data[0].address1
            addressformik.values.address2 = data[0].address2
            addressformik.values.city = data[0].city
            addressformik.values.state = data[0].state
            addressformik.values.country = data[0].country
            addressformik.values.zip = data[0].zip
            addressformik.values.email = data[0].email
            addressformik.values.id = data[0].id
            addressformik.values.phone = data[0].phone
            handleClosedFunction()
            // setUserAddress(data[0])
        } else {
            addressformik.values.first_name = ''

            addressformik.values.address1 = ''
            addressformik.values.address2 = ''
            addressformik.values.city = ''
            addressformik.values.state = ''
            addressformik.values.country = ''
            addressformik.values.zip = ''
            addressformik.values.email = ''
            addressformik.values.id = ''
            addressformik.values.phone = ''
        }
    }

    useEffect(() => {
        if (responseStatusCommuncation) {
            if (
                responseStatusCommuncation.from === 'userAddressUpdate' &&
                responseStatusCommuncation.status === 'success'
            ) {
                handleClosedFunction()
                setIsLoading(true)
                setTableBody([])

                formik.values.page = 1

                getUserAddressDetails(formik.values)
            }
        }
    }, [responseStatusCommuncation])

    const tableValues = [
        {
            field: 'id',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'ID',
        },
        {
            field: 'email',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Email',
        },
        {
            field: 'first_name',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'First Name / Last Name',
        },

        {
            field: 'address1',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Address1',
        },
        {
            field: 'address2',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Address2',
        },
        {
            field: 'city',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'City',
        },
        {
            field: 'phone',
            type: 'number',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Phone',
        },
        {
            field: 'country',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Country',
        },
        {
            field: 'zip',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Zip',
        },
        {
            field: 'action',
            type: 'button',
            clickID: 'id',
            secondaryClickID: 'user_id',
            clickType: 'edit',
            onclick: onClickEdit,
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            tooltipTitle: 'Edit Address',
            buttonType: 'edit',
        },
    ]

    const handleClosedFunction = () => {
        setToggleFullScreenPopup(!toggleFullScreenPopup)
    }

    useEffect(() => {
        if (allStates && allStates.length > 0) {
            // Extract the country from addressformik and fallback to global.defaultCountry
            const country =
                addressformik?.values?.country || global.defaultCountry

            // Filter states based on the selected country and ignoreStates
            const countrySelect = allStates.filter((state) => {
                const isValidCountry =
                    country && country.indexOf(state.countryCode) !== -1
                const isIgnoredState =
                    global.ignoreStates &&
                    global.ignoreStates.indexOf(state.isoCode) === -1
                return isValidCountry && isIgnoredState
            })

            // If there are valid states, update selectState
            if (countrySelect.length > 0) {
                setSelectState(true)
            } else {
                setSelectState(false)
            }
        }
    }, [addressformik?.values?.country, allStates, global]) // Update dependencies to track the relevant values

    useEffect(() => {
        let tepmpdata = [
            {
                label: t('First Name / Last Name'),
                type: 'text',
                placeholder: t('Enter your name'),
                class: 'col-12',
                name: 'first_name',
            },
            {
                label: t('Email Address'),
                type: 'text',
                placeholder: t('Enter your Email Address'),
                class: 'col-12',
                name: 'email',
            },
            {
                label: t('Mobile Number'),
                type: 'phone',
                placeholder: t('Enter your Mobile Number'),
                class: 'col-12',
                name: 'phone',
            },
            {
                label: t('Address1'),
                placeholder: t('Enter your address1'),
                class: 'col-12',
                type: 'text',
                name: 'address1',
            },
            {
                label: t('Address2'),
                placeholder: t('Enter your address2'),
                class: 'col-12',
                type: 'text',
                name: 'address2',
            },
            {
                label: t('City'),
                placeholder: t('Enter your city'),
                class: 'col-12',
                type: 'text',
                name: 'city',
            },
            {
                label: t('Country'),
                placeholder: t('Select your country'),
                class: 'col-12',
                type: 'select',
                options: allCountries
                    .filter(
                        (country) =>
                            global.ignoreCountry.indexOf(country.isoCode) === -1
                    )
                    .map((country) => {
                        let busCategoryChanged = {}
                        busCategoryChanged.show = country.name
                        busCategoryChanged.value = country.isoCode
                        return busCategoryChanged
                    }),
                name: 'country',
            },
            {
                label: t('State'),
                placeholder: t('Select your state'),
                class: `${selectState ? 'col-12' : 'd-none'}`,
                type: 'select',
                options: allStates
                    ?.filter((state) => {
                        // Ensure the country value is valid before filtering states
                        const country =
                            addressformik?.values?.country ||
                            global.defaultCountry

                        // Check if the country is valid and if the state belongs to that country
                        const isValidCountry =
                            country &&
                            state.countryCode &&
                            country.includes(state.countryCode)

                        // Ensure the state is not in the ignoreStates list
                        const isIgnoredState =
                            global.ignoreStates &&
                            !global.ignoreStates.includes(state.isoCode)

                        return isValidCountry && isIgnoredState
                    })
                    .map((buscat) => ({
                        show: buscat.name,
                        value: buscat.isoCode,
                    })),
                name: 'state',
            },
            {
                label: t('Zip'),
                placeholder: t('Enter your ZIP code'),
                class: 'col-12',
                type: 'text',
                name: 'zip',
            },
        ]
        const filteredTepmpData = tepmpdata.filter((field) => {
            if (field.name === 'state') {
                return field.options && field.options.length > 0
            }
            return true
        })

        setmapDataValue(filteredTepmpData)
    }, [selectState, addressformik?.values?.country, allCountries, allStates])

    const addressDetails = {
        formik: addressformik,
        data: mapDataValue,
    }

    useEffect(() => {
        if (userId) {
            setTableBody([])
            setIsLoading(true)
            formik.handleSubmit()
        }
    }, [userId])

    return (
        <>
            <CustomTable
                formik={formik.values}
                tableBody={tableBody}
                tableValues={tableValues}
                tableActions={[]}
                allData={userAddressData}
                isLoading={isLoading}
                loadingTemplate={'table'}
                changeTableFunction={getUserAddressDetails}
            />

            <CustomDialog
                open={toggleFullScreenPopup}
                title={<h3>{t('Address Details')}</h3>}
                function={handleClosedFunction}
                className="address-dialog"
            >
                <div className="addressInfo">
                    <form
                        onSubmit={addressformik.handleSubmit}
                        autoComplete="nofill"
                    >
                        <div>{mapData(addressDetails)}</div>
                        <div className="actionWrapper">
                            <PrimaryButton
                                btnSize="large"
                                type="submit"
                                label={t('Save')}
                                // disabled={disabled}
                            />
                        </div>
                    </form>
                </div>
            </CustomDialog>
        </>
    )
}
export default UserAddressDetails
